import React, { useState } from 'react'
import { defineMessages, FormattedMessage } from 'react-intl'

const steps = [
  {
    graphic: require('media/set-a-goal.png'),
    messages: defineMessages({
      title: {
        defaultMessage: '1 Set a goal',
        id: 'KetoSteps.step1.title',
      },
      text: {
        defaultMessage:
          'When creating your Lifesum account, we’ll ask you what your goal weight is and recommend a realistic and healthy pace to reach it. You might want to tweak it depending on if you have a specific deadline or if you want your journey to be easier (but a little longer).',
        id: 'KetoSteps.step1.text',
      },
    }),
  },
  {
    graphic: require('media/choose-a-plan.png'),
    messages: defineMessages({
      title: {
        defaultMessage: '2 Choose your keto plan',
        id: 'KetoSteps.step2.title',
      },
      text: {
        defaultMessage:
          'Our keto diet is available in three versions: Easy, Medium & Strict. Easy is a good choice when you want your body to adapt to a keto diet or after a longer time of ketosis when wanting to slowly include carbs again. Medium and especially Strict speeds up your weight loss like nothing else.',
        id: 'KetoSteps.step2.text',
      },
    }),
  },
  {
    graphic: require('media/plan-ahead.png'),
    messages: defineMessages({
      title: {
        defaultMessage: '3 Plan ahead',
        id: 'KetoSteps.step3.title',
      },
      text: {
        defaultMessage:
          'Successful keto dieters plan ahead. Take some time to find and save recipes you like and get in the habit of meal prepping. Also, make sure you always have some keto friendly goodies ready to avoid snaccidents ;)',
        id: 'KetoSteps.step3.text',
      },
    }),
  },
  {
    graphic: require('media/track-your-eating.png'),
    messages: defineMessages({
      title: {
        defaultMessage: '4 Track your eating',
        id: 'KetoSteps.step4.title',
      },
      text: {
        defaultMessage:
          'Tracking regularly is the #1 thing we see successful Lifesum users doing. It will allow us to make your journey easier and you to learn about nutrition and gain valuable insights about your health. Make sure to also turn on the water tracker: drinking water is more important than you think for weight loss!',
        id: 'KetoSteps.step4.text',
      },
    }),
  },
]

function KetoSteps() {
  const [currentStep, setCurrentStep] = useState(0)

  return (
    <div className="c-native-ad__steps type-17">
      <div
        className="c-native-ad__steps-inner"
        style={{
          transform: `translateX(${currentStep * -25}%)`,
        }}
      >
        {steps.map((step, i) => {
          return (
            <div className="c-native-ad__step" key={i}>
              <img
                className="my-16"
                style={{ maxHeight: '150px' }}
                src={step.graphic}
                alt=""
              />
              <h3 className="c-native-ad__step-heading">
                <FormattedMessage {...step.messages.title} />
              </h3>
              <p className="c-native-ad__step-text md:mb-32">
                <FormattedMessage {...step.messages.text} />
              </p>
            </div>
          )
        })}
      </div>
      <ul className="c-native-ad__steps-nav">
        {steps.map((_step, i) => {
          return (
            <li key={i} className="c-native-ad__steps-nav-item">
              <button
                onClick={() => setCurrentStep(i)}
                className={`c-native-ad__steps-nav-button${
                  currentStep === i
                    ? ' c-native-ad__steps-nav-button--current'
                    : ''
                }`}
              >
                <span className="sr-only">
                  <FormattedMessage
                    id="KetoSteps.showStep"
                    defaultMessage="Show step {step}"
                    values={{ step: i + 1 }}
                  />
                </span>
                {i + 1}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default KetoSteps
